import React from 'react'
import { useEffect } from 'react';
import { useContext } from 'react';
import { Link } from 'react-router-dom'
import { deleteCusFeedback } from '../../../action';
import { GlobalState } from '../../../GlobalState';
import { TabTitle } from '../../../util/titleChanger'
import { toast, ToastContainer } from 'react-toastify';
import ReactPaginate from 'react-paginate'
import Loading from '../../../util/Loading';

export default function CustomerFeedbackDashboard() {
    TabTitle('Customer feedback dashboard');
    const state = useContext(GlobalState);
    const signInUser = JSON.parse(localStorage.getItem('user_data'));

    const [cusFeedbacks] = state.customerFeedbackAPI.cusFeedbacks;

    //Import state
    const [rowPerPage] = state.customerFeedbackAPI.rowPerPage;
    const [pageNumber, setPageNumber] = state.customerFeedbackAPI.pageNumber;
    const [totalPages] = state.customerFeedbackAPI.totalPages;
    const [setSearch] = state.customerFeedbackAPI.search;
    const [callback, setCallback] = state.customerFeedbackAPI.callback;

    const pageNumberHandler = (data) => {
        let newPageNumber = data.selected + 1;
        setPageNumber(newPageNumber)
    }

    const searchHandler = (e) => {
        e.preventDefault();
        setPageNumber(1);
        setSearch(e.target.value ? e.target.value : "");
    }

    useEffect(() => { }, [rowPerPage, pageNumber, cusFeedbacks])

    const deleteCusFeedbackHandler = (id) => {
        deleteCusFeedback(id, signInUser.id, res => {
            if (res.status === 200) {
                toast.success("Feedback deleted successfully!");
                setCallback(!callback)
            } else {
                toast.error(res.data);
                setCallback(!callback)
            }
        })
    }

    const dateConverter = (date) => {
        let convertedDate = new Date(date).toISOString().slice(0, 10);
        return convertedDate
    }

    return (
        <div className='form-container'>
            <div className="table">
                <div className="table_header">
                    <p>Customer Feedback Details</p>
                    <div>
                        <input
                            type="text"
                            name="search"
                            id="search"
                            placeholder='Search customer here...'
                            onChange={(e) => searchHandler(e)}
                        />
                        <Link to="/customer-feedback-form"><button className="add_new">+ Add New</button></Link>
                    </div>
                </div>

                {
                    cusFeedbacks.count === 0 ? <div className="loading-page-container"><Loading /></div>
                        : <div className="table_section">
                            <table>
                                <thead>
                                    <tr>
                                        <th>Customer Name</th>
                                        <th>Feedback</th>
                                        <th>Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        cusFeedbacks.count > 0 ? cusFeedbacks.data.map(feedback => (
                                            <tr key={feedback.id}>
                                                <td>{feedback.customer.first_name + " " + feedback.customer.last_name}</td>
                                                <td>{feedback.note}</td>
                                                <td>
                                                    <Link to={`/customer-feedback-form/${feedback.id}`}><button><i className="uil uil-eye"></i></button></Link>
                                                    <Link to={'#'}></Link>
                                                    <button onClick={() => deleteCusFeedbackHandler(feedback.id)}><i className="uil uil-trash-alt"></i></button>
                                                </td>
                                            </tr>
                                        ))
                                            : <tr>
                                                <td colSpan={3}>Can not found any feedback details.</td>
                                            </tr>
                                    }
                                </tbody>
                            </table>
                        </div>
                }

                <ReactPaginate
                    breakLabel="..."
                    nextLabel="next >"
                    onPageChange={pageNumberHandler}
                    marginPagesDisplayed={2}
                    pageCount={totalPages}
                    previousLabel="< previous"
                    renderOnZeroPageCount={null}
                    containerClassName='pagination'
                    pageLinkClassName='page-num'
                    previousLinkClassName='page-num'
                    nextLinkClassName='page-num'
                    activeLinkClassName='active-num'
                />
            </div>
            <ToastContainer />
        </div>
    )
}
